import type { FC } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import { FormDatePicker } from "@/components/UiKit"

export const DownloadPriceListForm: FC = () => {
  const { control } = useFormContext()

  return (
    <form>
      <FormDatePicker
        control={control}
        name='effectiveDate'
        className='w-full'
        label='Effective Date'
        data-testid='company.download-price-list.effective-date-field'
      />
    </form>
  )
}
